import { Component } from '@angular/core';
import { HeaderComponent } from '../../layout/header/header.component';
import { NavbarComponent } from '../../layout/navbar/navbar.component';
import { RoutelinksService } from '../../services/core/routelinks.service';
import { SidebarComponent } from '../../layout/sidebar/sidebar.component';

@Component({
  selector: 'app-discount',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent,SidebarComponent],
  templateUrl: './discount.component.html',
  styleUrl: './discount.component.css'
})
export class DiscountComponent {
  links: any[] = [];

  constructor(private routelinks: RoutelinksService) { }

  ngOnInit(): void {
    this.links = this.routelinks.linksDiscount; // Inicializa la propiedad en ngOnInit
  }
}
